
/* styles */
require("!!vue-style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-b17898c4&scoped=true!sass-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ModalCloseButton.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ModalCloseButton.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-b17898c4!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ModalCloseButton.vue"),
  /* scopeId */
  "data-v-b17898c4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/modal/type/ModalCloseButton.vue
// module id = 247
// module chunks = 2